import React, { useEffect } from "react";
import axios from 'axios';
import { useDispatch } from "react-redux";
import { setList as cartSetList, setBeverages, setUnits } from "../redux/Cart";
import { setList as pourSetList } from "../redux/Pour";
import { addActiveTransaction, addTransaction, clearData, requestEnd, requestStart } from "../redux/Transaction";
import { setCredit, clearCredit, setUser } from "../redux/User";
import Cookies from 'js-cookie';
import {addPayment} from "../redux/Payment";

const GetDataFromAPI = () => {
    const dispatch = useDispatch();
    const url = process.env.REACT_APP_API_URL + '/getAllByUser/' + process.env.REACT_APP_USER;

    useEffect(() => {
        dispatch(requestStart());
        dispatch(clearData());
        dispatch(clearCredit());

        let customer_id = localStorage.getItem('customer_id') || "-1";
        const apiToken = Cookies.get('api_token');

        const fetchData = async () => {
            try {

                const response = await axios.post(url, {
                    customer_id: customer_id
                }, {
                    headers: {
                        'Authorization': `Bearer ${apiToken}`,
                        'Content-Type': 'application/json'
                    }
                });

                const data = response.data;

                dispatch(cartSetList(data.cart));
                data.beverages.forEach((beverage: any) => {
                    beverage.unitName = data.units.find((u: any) => u.id === beverage.unit_id)?.name;
                });

                data.pours.forEach((pour: any) => {
                    pour.beverageDetail = data.beverages.find((b: any) => b.id === pour.beverage_id);
                });

                dispatch(pourSetList(data.pours));
                dispatch(setUnits(data.units));
                dispatch(setBeverages(data.beverages));

                data.transactions.map((transaction: any) => {
                    dispatch(addTransaction(transaction));
                    if (transaction.qtyUsed !== transaction.qty) {
                        dispatch(addActiveTransaction(transaction));
                    }
                });

                if (customer_id === "-1") {
                    localStorage.setItem('customer_id', data.customer_id);
                }

                if(apiToken) {

                    if(data.user == ""){
                        Cookies.set('api_token', "", { expires: -1 });
                    }else {

                        dispatch(setCredit(data.credit));
                        dispatch(setUser(data.user));

                        data.payments.map((payment: any) => {
                            dispatch(addPayment(payment));
                        });

                    }

                }

            } catch (error) {
                console.error('Error fetching data from API:', error);
            } finally {
                dispatch(requestEnd());
            }
        };

        fetchData();
    }, [url, dispatch]);

    return (
        <>
        </>
    );
}

export default GetDataFromAPI;
